import { twMerge } from "tailwind-merge";

interface TabCheckboxProps {
    className?: string;
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    checked: boolean;
    id: string;
    txt: string;
    value: string;
}

export default function TabCheckbox({ className = "", handleChange, checked = false, id, txt = "", value }: TabCheckboxProps) {
    const style = twMerge("flex items-center text-[#5A5C63] font-[500] cursor-pointer", className);
    const checkStyle =
        "bg-white border border-[#E1E2E4] rounded-[20px] p-[6px_12px] text-[13px] text-[#878A93] font-[500] transition-all relative after:absolute after:content-[''] after:w-[18px] after:h-[18px] after:bg-ic_check after:bg-center after:-right-[15px] after:top-1/2 after:-translate-y-1/2 after:transition after:delay-75 after:opacity-0 overflow-hidden";
    const checkOnStyle = twMerge(checkStyle, "bg-[#FFE5D5] text-[#FF7B2E] border-[#FFE5D5] pr-[36px] after:right-[15px] after:opacity-100");

    return (
        <>
            <label htmlFor={id} className={style}>
                <input type={`checkbox`} className="hidden" id={id} checked={checked} onChange={handleChange} value={value} />
                <span className={checked ? checkOnStyle : checkStyle}>{txt}</span>
            </label>
        </>
    );
}
